export enum TOrganizationType {
    SwMerchant = 0,
    Partner = 1,
    CallCenter = 2,
}
